import script from "./AddAdminForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAdminForm.vue?vue&type=script&setup=true&lang=js"

import "./AddAdminForm.vue?vue&type=style&index=0&id=587b43f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587b43f1"]])

export default __exports__